var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('button',{on:{"click":_vm.close}},[(_vm.windowWidth > 593 && _vm.windowWidth < 768)?_c('CloseIcon'):_c('CloseIconSmall')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }